$(document).ready(function() {
  $(".set > span").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".ac-content")
        .slideUp(200);
      $(".set > span i")
        .removeClass("la-minus")
        .addClass("la-plus");
    } else {     
      $(".set > span i")
        .removeClass("la-minus")
        .addClass("la-plus");
      $(this)
        .find("i")
        .removeClass("la-plus")
        .addClass("la-minus");
      $(".set > span").removeClass("active");
      $(this).addClass("active");
      $(".ac-content").slideUp(200);
      $(this)
        .siblings(".ac-content")
        .slideDown(200);
    }
  });
});


jQuery(document).ready(function() {
  jQuery("a.size").simplePopup({ type: "html", htmlSelector: "#size" });
});
